import React from "react";
import { Phone, Headphones } from "lucide-react";

const SUPPORT_NUMBER = "6204298565";
const SUPPORT_DISPLAY = "+91 62042 98565";

export default function SupportBar() {
  return (
    <div
      data-testid="support-bar"
      className="fixed top-0 inset-x-0 z-[60] bg-gradient-to-r from-[#B45309] via-[#D97706] to-[#F59E0B] text-white text-[13px] shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 lg:px-10 h-9 flex items-center justify-center sm:justify-between gap-3">
        <div className="hidden sm:flex items-center gap-2 opacity-95">
          <Headphones className="w-3.5 h-3.5" />
          <span className="font-medium tracking-wide">24×7 Care Support &amp; Enquiries</span>
        </div>
        <a
          data-testid="support-bar-call"
          href={`tel:+91${SUPPORT_NUMBER}`}
          className="flex items-center gap-2 group font-semibold hover:text-[#FEF3C7] transition-colors"
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-white opacity-70 animate-ping" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-white" />
          </span>
          <Phone className="w-3.5 h-3.5" />
          <span>Talk to us:</span>
          <span className="underline underline-offset-2 decoration-white/50 group-hover:decoration-white">
            {SUPPORT_DISPLAY}
          </span>
        </a>
        <span className="hidden sm:block text-[11px] opacity-80">Mon–Sun · IST</span>
      </div>
    </div>
  );
}
